function open_dialog(message){
    var unit = $('input[name="search_condition[select_type]"]:checked').val();
    var select = $("#search_condition_project_id").val();
    if (unit == 1){
        select = $("#search_condition_delivery_name").val();
    }
    if (select == null){
        jAlert(message, "");
        return false;
    }

    var data_string="";
    data_string = data_string + "&" + "search_condition=true"
    //data_string = data_string + "&" +"dialog_flg=true"
    data_string = data_string + "&" +"p_unit=" + unit;
    data_string = data_string + "&" +"p_select=" + select;
    $('#open_dialog').attr('href', $('#open_dialog').attr('data-href') + data_string);
    ajaxEnable(true);
    lockWindow();
}